import React from 'react';
import { PMCConfig } from '@kyruus/types';
import { Paper } from '@biome-design-system/ui/Paper';
import type { Log } from 'Src/types';
import { getConfigProperty } from 'Common/config';
import { NeedHelpSection } from './NeedHelpSection';
import { PatientPortalSection } from './PatientPortalSection';
import { SidebarContainer } from '../styles';

interface NoResultsSidebarProps {
  config: PMCConfig;
  log: Log;
}
export const NoResultsSidebar = ({ config, log }: NoResultsSidebarProps) => {
  const needHelpPhoneNumber = getConfigProperty(
    config,
    'no_results_page.need_help_phone_number'
  );
  const patientPortalUrl = getConfigProperty(
    config,
    'no_results_page.patient_portal_url'
  );
  if (!patientPortalUrl && !needHelpPhoneNumber) return null;
  return (
    <SidebarContainer>
      <Paper
        component="aside"
        sx={(theme) => ({
          '& > section': {
            padding: theme.spacing(3)
          },
          '& > section:not(:last-child)': {
            borderBottom: `1px solid ${theme.palette.divider}`
          }
        })}
      >
        {needHelpPhoneNumber && (
          <NeedHelpSection
            needHelpPhoneNumber={needHelpPhoneNumber}
            log={log}
          />
        )}
        {patientPortalUrl && (
          <PatientPortalSection patientPortalUrl={patientPortalUrl} log={log} />
        )}
      </Paper>
    </SidebarContainer>
  );
};
